import {MediaDeviceStatus, PluginStatus, Publisher} from "../../../constants/Janus";
import {VideoPubEvent} from "../../../constants/Janus/VideoRoom/Publisher";

interface PublisherAction {
    type: VideoPubEvent;
    payload?: any;
}

interface PublisherState {
    videoPlugin: any;
    opaqueId: string;
    username: string;
    id: number | undefined;
    privateId: number | undefined;

    publish: boolean;

    error: string;
    consentDialog: boolean;
    iceState: boolean;
    mediaState: any;
    webrtcState: boolean;
    slowLink: any;

    joined: boolean;
    publishers: any[];
    newPublishers: any[],
    destroyed: boolean;

    localStream: any;
    leaving: number | undefined;
    unpublished: number | undefined;
    errorEvent: string;
    cleanup: boolean;

    pluginStatus: PluginStatus;
    mediaStatus: MediaDeviceStatus,
}


export const initVideoPubState = {
    videoPlugin: null,
    opaqueId: "",
    username: "",
    id: undefined,
    privateId: undefined,

    publish: false,

    error: "",
    consentDialog: false,
    iceState: false,
    mediaState: null,
    webrtcState: false,
    slowLink: null,

    joined: false,
    publishers: [],
    newPublishers: [],
    destroyed: false,

    localStream: null,
    leaving: undefined,
    unpublished: undefined,
    errorEvent: "",
    cleanup: false,

    mediaStatus: MediaDeviceStatus.None,
    pluginStatus: PluginStatus.None,
};

export const videoRoomPubReducer = (state: PublisherState, {type, payload}: PublisherAction) => {
    switch (type) {
        //Video plugin event
        case VideoPubEvent.SUCCESS:
            return {
                ...state,
                pluginStatus: PluginStatus.Attached
            }
        case VideoPubEvent.ERROR:
            return {
                ...state,
                pluginStatus: PluginStatus.Error,
                errorEvent: payload
            }
        case VideoPubEvent.CONSENT_DIALOG:
            return {
                ...state,
                consentDialog: payload
            }
        case VideoPubEvent.ICE_STATE:
            return {
                ...state,
                iceState: payload
            }
        case VideoPubEvent.MEDIA_STATE:
            const tempMediaStatus = payload?.on ? MediaDeviceStatus.Published : MediaDeviceStatus.Unpublished;
            return {
                ...state,
                mediaState: payload,
                mediaStatus: tempMediaStatus
            }
        case VideoPubEvent.WEBRTC_STATE:
            return {
                ...state,
                webrtcState: payload
            }
        case VideoPubEvent.JOINED:
            return {
                ...state,
                joined: true,
                id: payload["id"],
                privateId: payload["private_id"],
                publishers: payload["publishers"] ? payload["publishers"] : [],
                newPublishers: payload["publishers"] ? payload["publishers"] : [],
            }
        case VideoPubEvent.DESTROYED:
            return {
                ...state,
                ...initVideoPubState,
                destroyed: true,
            }
        case VideoPubEvent.PUBLISHERS:
            return {
                ...state,
                publishers: [...state.publishers, ...payload],
                newPublishers: payload,
            }
        case VideoPubEvent.LEAVING:
            return {
                ...state,
                leaving: payload
            }
        case VideoPubEvent.UNPUBLISHED:
            let newPublishers = state.publishers.filter((publisher: Publisher) => publisher.id !== payload);
            return {
                ...state,
                publishers: newPublishers
            }
        case VideoPubEvent.ERROR_EVENT:
            return {
                ...state,
                errorEvent: payload
            }
        case VideoPubEvent.ON_LOCAL_STREAM:
            return {
                ...state,
                localStream: payload
            }
        case VideoPubEvent.ON_CLEAN_UP:
            return {
                // ...initVideoPubState
                ...state,
                cleanup: true,
                publish: false,
            }
        case VideoPubEvent.PUBLISHER_LEFT: {
            // console.log("PUBLISHER_LEFT", payload, state.publishers, state.publishers.filter((publisher: Publisher) => publisher.id !== payload))
            return {
                ...state,
                publishers: state.publishers.filter((publisher: Publisher) => publisher.id !== payload),
                leaving: payload,
            }
        }
        case VideoPubEvent.SET:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case VideoPubEvent.CLEAR:
            return {
                ...state,
                ...initVideoPubState,
            };
        default:
            return state;
    }
};

// const updateFeedData = (remoteFeeds: any[], data: any) => {
//     let found = remoteFeeds.find((fs: any) => fs.id === data.id);
//
//     if (found) {
//         return remoteFeeds.map(obj => {
//             if (obj.id === data.id) {
//                 return {...obj, ...data};
//             }
//             return obj;
//         })
//     } else {
//         return [...remoteFeeds, data]
//     }
// };